import axios from 'axios';
import {
    ADD_SHIPMENT_IDENTIFIER,
    CHANGE_CONNECTIONS,
    CHANGE_REQUEST,
    CLEAR_PROVIDER,
    CLEAR_REQUEST,
    CLEAR_TRUCK_AGREEMENT,
    CLOSE_SNACKBAR,
    DISABLE_AGREEMENT_OPERATIONS,
    DISABLE_CONNECTION_OPERATIONS,
    DISPLAY_SNACKBAR,
    ENABLE_AGREEMENT_OPERATIONS,
    ENABLE_CONNECTION_OPERATIONS,
    FILTER_CONNECTIONS,
    GET_AGREEMENTS,
    UPDATE_CURRENT_ACCOUNT_TYPE,
    UPDATE_CONNECTION_TYPE,
    GET_CONNECTIONS,
    SET_SORT_ORDER,
    SET_SORT_FIELD,
    GET_GROUPNAMES,
    GET_SHIPPER_CODES,
    GET_PROVIDER_ACCOUNTS,
    GET_ACCOUNT_TYPES,
    HIDE_TABLE,
    RESET_AGREEMENT_LIST,
    RESET_SELECTED_DATASOURCE,
    SELECTED_CONNECTION,
    SET_DATASOURCE,
    SET_NEW_AGREEMENTS,
    SET_PROVIDER,
    SET_SELECTED_DATASOURCE,
    SET_SELECTED_SHIPPER,
    SHOW_TABLE,
    UPDATE_NEW_AGREEMENT,
    SHIPPER_CODES_LOADED,
    SET_DATASOURCE_CHECKCALLTYPE,
    CHECK_CALL_UPDATE_FLAG,
    CHECK_CALL_DELAY_FLAG,
    CLEAR_CHECK_CALL_DATA,
    CHECK_CALL_FETCH_FLAG,
    SET_SELECTED_GROUP_NAME,
    CONNECTION_CURRENT_OPERATION,
    AGREEMENT_CURRENT_OPERATION,
    CLEAR_GROUPNAMES,
    SHIPPER_GROUP_LOADED,
    IS_ACCOUNTS_LOADED,
    ACCOUNT_TYPE_LOADED,
    SHOW_AGREEMENTS,
    HIDE_AGREEMENTS,
    AGREEMENT_SAVE_FLAG,
    STORE_NEW_CONNECTION_ID,
    GET_TIMEZONES,
    UPDATE_SELECTED_ACCOUNT_TYPE
} from '../actions/types';
import * as Constants from 'constants/Constants';
import { SHOW_DANGER_BAR, SHOW_SUCCESS_BAR } from 'store/actions/types';
import {
    getAgreementsByConnectionId,
    toggleCreateConnection,
    resetUserInputs
} from './agreementAction';
import { PAGE, PAGE_SIZE, SORT_ORDER, SORT_FIELD } from 'constants/Constants';
import { isNotBlank } from 'components/Common/Utils/StringUtils';

export const getVisibilityConnections = ({ page, size, sortOrder, sortField, searchTerm }) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        let URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections`;
        dispatch(clearVisibilityProvider());
        dispatch({
            type: HIDE_TABLE
        });

        const filteredParams = isNotBlank(searchTerm) ? `name=re='(?i)${searchTerm}'` : '';

        const params = {
            size,
            page,
            sortOrder,
            sortField
        };
        if (filteredParams) {
            params.filter = filteredParams;
        }

        const adminParams = {
            params: {
                filter: isNotBlank(filteredParams)
                    ? `accountId==${sessionValue?.selected_accountId};${filteredParams}`
                    : `accountId==${sessionValue?.selected_accountId}`,
                size,
                page,
                sortOrder,
                sortField
            }
        };
        axios
            .get(URL, sessionValue?.isCarrier ? { params } : adminParams)
            .then((response) => {
                dispatch({
                    type: GET_CONNECTIONS,
                    payload: response.data,
                    size
                });
            })
            .catch((error) => {
                if (error.response.status !== 401) {
                    const message = 'Error while fetching connections';
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: message
                    });
                }
            })
            .finally(() => {
                dispatch({
                    type: SHOW_TABLE
                });
            });
    };
};

export const getConnectionById = (connectionId) => (dispatch) => {
    const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections/${connectionId}`;

    axios.get(URL).then((response) => {
        dispatch({
            type: SET_PROVIDER,
            payload: response.data
        });
        dispatch({
            type: CHANGE_CONNECTIONS,
            payload: response.data
        });
    });
};

export const clearVisibilityProvider = () => {
    return {
        type: CLEAR_PROVIDER,
        payload: []
    };
};

export const getAgreementsByConnection = (connectionId) => (dispatch) => {
    const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections/${connectionId}/agreements`;

    dispatch({
        type: SELECTED_CONNECTION,
        payload: connectionId
    });
    dispatch({
        type: AGREEMENT_CURRENT_OPERATION,
        payload: 'Fetching Agreements'
    });
    dispatch(hideAgreements());
    axios
        .get(URL)
        .then((response) => {
            const data = Object.keys(response.data).map((key) => response.data[key]);
            dispatch({
                type: GET_AGREEMENTS,
                payload: data
            });
        })
        .catch((error) => {
            const message = 'Error while fetching agreements';
            const type = 'error';
            dispatch({
                type: DISPLAY_SNACKBAR,
                payload: [true, message, type]
            });
        })
        .finally(() => {
            dispatch(showAgreements());
        });
};

export const setNewAgreement = (newAgreement) => (dispatch) => {
    dispatch({
        type: SET_SELECTED_SHIPPER,
        payload: newAgreement.name
    });
    dispatch({
        type: SET_NEW_AGREEMENTS,
        payload: newAgreement
    });
};

export const updateNewAgreement = (agreements) => (dispatch) => {
    dispatch({
        type: UPDATE_NEW_AGREEMENT,
        payload: agreements
    });
};

export const showAgreements = () => {
    return {
        type: SHOW_AGREEMENTS,
        payload: true
    };
};

export const hideAgreements = () => {
    return {
        type: HIDE_AGREEMENTS,
        payload: false
    };
};

export const addShipmentIdentifiersToAgreement = (newAgreement) => (dispatch) => {
    dispatch({
        type: SET_SELECTED_SHIPPER,
        payload: newAgreement.name
    });
    dispatch({
        type: ADD_SHIPMENT_IDENTIFIER,
        payload: newAgreement.shipment_identifier
    });
};

export const saveVisibilityConnections = (connection, isAgreementOnly) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections`;

        dispatch({
            type: HIDE_TABLE
        });
        dispatch({
            type: isAgreementOnly ? DISABLE_AGREEMENT_OPERATIONS : DISABLE_CONNECTION_OPERATIONS
        });
        dispatch({
            type: isAgreementOnly ? AGREEMENT_CURRENT_OPERATION : CONNECTION_CURRENT_OPERATION,
            payload: isAgreementOnly ? 'Creating Agreement' : 'Creating Connection'
        });
        axios
            .post(URL, connection, {
                headers: {
                    tenant_id: sessionValue.tenant_id,
                    user_id: sessionValue.userId,
                    company_id: sessionValue.people_net_id,
                    account_id: sessionValue.accountId,
                    Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
                }
            })
            .then((response) => {
                dispatch(toggleAgreementSaveFlag(true));

                dispatch({
                    type: CLEAR_REQUEST
                });
                dispatch({
                    type: CLEAR_TRUCK_AGREEMENT
                });
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: isAgreementOnly
                        ? 'Agreement created successfully'
                        : 'Connection created successfully'
                });
                if (!isAgreementOnly) {
                    dispatch(
                        getVisibilityConnections({
                            page: PAGE,
                            size: PAGE_SIZE,
                            sortOrder: SORT_ORDER.ASC,
                            sortField: SORT_FIELD,
                            searchTerm: ''
                        })
                    );
                }
                if (response.data !== undefined && response.data.connection !== undefined) {
                    dispatch(storeNewConnectionId(response.data.connection.id));
                    dispatch(getAgreementsByConnectionId(response.data.connection.id)); //must be removed
                }
                dispatch(toggleCreateConnection(false));
                dispatch(resetUserInputs());
            })
            .catch((error) => {
                dispatch({
                    type: SHOW_DANGER_BAR,
                    payload: isAgreementOnly
                        ? 'Error while creating agreement'
                        : 'Error while creating connection'
                });
            })
            .finally(() => {
                dispatch({
                    type: SHOW_TABLE
                });
                dispatch({
                    type: ENABLE_CONNECTION_OPERATIONS
                });
                dispatch({
                    type: ENABLE_AGREEMENT_OPERATIONS
                });
            });
    };
};

export const setSortOrder = (value) => (dispatch) => {
    dispatch({
        type: SET_SORT_ORDER,
        payload: value
    });
};

export const setSortField = (value) => (dispatch) => {
    dispatch({
        type: SET_SORT_FIELD,
        payload: value
    });
};

export const updateVisibilityConnections = (connection) => {
    return (dispatch) => {
        const url = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections/${connection?.connectionIDs?.[0]}`;
        dispatch({
            type: HIDE_TABLE
        });
        dispatch({
            type: DISABLE_CONNECTION_OPERATIONS
        });
        dispatch({
            type: CONNECTION_CURRENT_OPERATION,
            payload: 'Updating Connection'
        });
        const params = {
            status: connection?.status
        };

        axios
            .patch(url, params)
            .then(() => {
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Connection status updated successfully'
                });
                dispatch(
                    getVisibilityConnections({
                        page: PAGE,
                        size: PAGE_SIZE,
                        sortOrder: SORT_ORDER.ASC,
                        sortField: SORT_FIELD,
                        searchTerm: ''
                    })
                );
            })
            .catch(() => {
                dispatch({
                    type: SHOW_TABLE
                });
            })
            .finally(() => {
                // dispatch({
                //   type: SHOW_TABLE
                // });
                dispatch({
                    type: ENABLE_CONNECTION_OPERATIONS
                });
            });
    };
};

export const getAgreementsByProviderId = (provider_id, accountId) => (dispatch) => {
    const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/agreements`;

    const params = {
        account_id: accountId,
        provider_id
    };
    axios.get(URL, { params }).then((response) => {
        dispatch({
            type: CHANGE_REQUEST,
            payload: response.data
        });
    });
};

export const getProviderAccounts = (selectedType, searchQuery, sessionValue) => (dispatch) => {
    const sessionAccountType = sessionValue?.accountType;
    let URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/accounts?accountType=${selectedType}`;
    let accountType =
        selectedType === Constants.AGREEMENT_TYPE_VISIBILITY_UI
            ? Constants.ACCOUNT_TYPE_VISIBILITY_API
            : selectedType;
    let filterType =
        selectedType === Constants.AGREEMENT_TYPE_VISIBILITY_UI &&
        sessionAccountType.includes(Constants.VISIBILITY_PROVIDER)
            ? `&filterAccount=false`
            : '';
    let baseURL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/accounts?type=${accountType}${filterType}`;
    if (isNotBlank(searchQuery)) {
        URL = URL + `&searchQuery=${searchQuery}`;
    }
    let finalURL = selectedType !== Constants.ACCOUNT_TYPE_SHIPPER ? baseURL : URL;
    dispatch(toggleProviderLoaded(false));
    axios
        .get(finalURL)
        .then((response) => {
            dispatch({
                type: GET_PROVIDER_ACCOUNTS,
                payload: response.data
            });
        })
        .finally(() => {
            dispatch(toggleProviderLoaded(true));
        });
};

export const toggleProviderLoaded = (flag) => (dispatch) => {
    if (!flag) {
        dispatch({
            type: GET_PROVIDER_ACCOUNTS,
            payload: []
        });
    }
    dispatch({
        type: IS_ACCOUNTS_LOADED,
        payload: flag
    });
};

export const updateSelectedAccountType = (value) => (dispatch) => {
    dispatch({
        type: UPDATE_SELECTED_ACCOUNT_TYPE,
        payload: value
    });
};

export const getAccountTypes = () => (dispatch) => {
    const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/accounts/configurations?configType=accountTypes`;
    dispatch({
        type: ACCOUNT_TYPE_LOADED,
        payload: false
    });
    axios
        .get(URL)
        .then((response) => {
            dispatch({
                type: GET_ACCOUNT_TYPES,
                payload: response.data
                    .filter(
                        (type) =>
                            type === Constants.ACCOUNT_TYPE_VISIBILITY ||
                            type === Constants.AGREEMENT_TYPE_OEM ||
                            (Constants.DVIR_TYPE_ENABLED && type === Constants.ACCOUNT_TYPE_DVIR) ||
                            type === Constants.ACCOUNT_TYPE_VENDOR
                    )
                    .map(function (type) {
                        return type.replace(
                            Constants.ACCOUNT_TYPE_VISIBILITY,
                            Constants.AGREEMENT_TYPE_VISIBILITY_UI
                        );
                    })
            });
        })
        .finally(() => {
            dispatch({
                type: ACCOUNT_TYPE_LOADED,
                payload: true
            });
        });
};

export const updateCurrentAccountType = (value) => (dispatch) => {
    dispatch({
        type: UPDATE_CURRENT_ACCOUNT_TYPE,
        payload: value
    });
};

export const updateConnectionType = (value) => (dispatch) => {
    dispatch({
        type: UPDATE_CONNECTION_TYPE,
        payload: value
    });
};

export const getDataSource = () => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;

        const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/datasource`;

        axios
            .get(URL, {
                headers: {
                    tenant_id: sessionValue.tenant_id,
                    Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
                }
            })
            .then((response) => {
                dispatch({
                    type: SET_DATASOURCE,
                    payload: response.data
                });
            });
    };
};

export const getDataSourceWithCheckCallType = () => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const access_token = sessionStorage.getItem('access_token');

        const baseURL = `https://${Constants.TRUSTCENTER_ENDPOINT}/`;
        const url = '/api/v1/trustcenter/carrierconfig';

        const account_id = sessionValue.selected_accountId
            ? sessionValue.selected_accountId
            : sessionValue.accountId;

        const headers = {
            tenant_id: sessionValue.tenant_id,
            account_id,
            Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
        };

        axios
            .create({ baseURL, headers })
            .get(url)
            .then((response) => {
                dispatch({
                    type: SET_DATASOURCE_CHECKCALLTYPE,
                    payload: response.data
                });
                dispatch({
                    type: CHECK_CALL_FETCH_FLAG,
                    payload: false
                });
            })
            .catch((error) => {
                dispatch({
                    type: SHOW_DANGER_BAR,
                    payload: 'Data source fetch has failed'
                });
                dispatch({
                    type: CHECK_CALL_FETCH_FLAG,
                    payload: true
                });
            });
    };
};

export const resetCallFetchFlag = (flag) => {
    return {
        type: CHECK_CALL_FETCH_FLAG,
        payload: flag
    };
};

export const clearCheckCallData = () => {
    return {
        type: CLEAR_CHECK_CALL_DATA,
        payload: {}
    };
};

export const checkCallUpdateFlag = (flag) => {
    return {
        type: CHECK_CALL_UPDATE_FLAG,
        payload: flag
    };
};

export const saveDataSourceWithCheckCallType = (dataSourceList) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;

        const url = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/carrierconfig`;

        const access_token = sessionStorage.getItem('access_token');

        const account_id = sessionValue.selected_accountId
            ? sessionValue.selected_accountId
            : sessionValue.accountId;

        const headers = {
            tenant_id: sessionValue.tenant_id,
            account_id,
            Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
        };

        dispatch({
            type: CHECK_CALL_DELAY_FLAG,
            payload: true
        });

        axios
            .create({ headers })
            .post(url, dataSourceList)
            .then((res) => {
                dispatch({
                    type: CHECK_CALL_DELAY_FLAG,
                    payload: false
                });
                dispatch({
                    type: CHECK_CALL_UPDATE_FLAG,
                    payload: true
                });
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Configuration saved successfully'
                });
            })
            .catch((error) => {
                dispatch({
                    type: SHOW_DANGER_BAR,
                    payload: 'Failed to save the configuration'
                });
                dispatch({
                    type: CHECK_CALL_UPDATE_FLAG,
                    payload: false
                });
                dispatch({
                    type: CHECK_CALL_DELAY_FLAG,
                    payload: false
                });
            });
    };
};

export const resetShipperCodeLoaded = () => (dispatch) => {
    dispatch({
        type: SHIPPER_CODES_LOADED,
        payload: false
    });
};

export const resetShipperGroupNameLoaded = () => (dispatch) => {
    dispatch({
        type: SHIPPER_GROUP_LOADED,
        payload: false
    });
};

export const getShipperCodes = (dataSourceId, companyCode) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const tenant_id = sessionValue.tenant_id;
        const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/datasource/${dataSourceId}/shippercodes`;

        const params = {
            companyCode: companyCode
        };
        dispatch({
            type: SHIPPER_CODES_LOADED,
            payload: false
        });

        axios
            .get(URL, {
                headers: {
                    tenant_id,
                    Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
                },
                params
            })
            .then((response) => {
                dispatch({
                    type: GET_SHIPPER_CODES,
                    payload: response.data
                });
            })
            .finally(() => {
                dispatch({
                    type: SHIPPER_CODES_LOADED,
                    payload: true
                });
            });
    };
};

export const clearShipperCodes = () => (dispatch) => {
    dispatch({
        type: GET_SHIPPER_CODES,
        payload: []
    });
};

export const clearGroupNames = () => (dispatch) => {
    dispatch({
        type: CLEAR_GROUPNAMES,
        payload: []
    });
};

export const getGroupNames = (name) => (dispatch) => {
    const url = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/groups`;

    // dispatch(clearGroupNames());

    dispatch({
        type: SHIPPER_GROUP_LOADED,
        payload: false
    });

    const headers = {
        Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
    };
    const params = {
        name
    };

    axios
        .create()
        .get(url, { headers, params })
        .then((res) => {
            dispatch({
                type: GET_GROUPNAMES,
                payload: res.data
            });
            dispatch({
                type: SHIPPER_GROUP_LOADED,
                payload: true
            });
        });
};

// export const getShipmentIdentifiers = () => {
//   return (dispatch, getState) => {
//     const { sessionValue } = getState().session;
//     const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/shipmentidentifiers`;

//     axios
//       .get(URL, {
//         headers: { tenant_id: sessionValue.tenant_id }
//       })
//       .then(response => {
//         dispatch({
//           type: GET_SHIPPER_IDENTIFIER,
//           payload: response.data
//         });
//       });
//   };
// };

export const setSelectedDataSource = (dataSourceId) => {
    return {
        type: SET_SELECTED_DATASOURCE,
        payload: dataSourceId
    };
};

export const setSelectedGroupName = (groupName) => {
    return {
        type: SET_SELECTED_GROUP_NAME,
        payload: groupName
    };
};

export const resetSelectedDataSource = () => {
    return {
        type: RESET_SELECTED_DATASOURCE
    };
};

export const resetAgreementList = () => {
    return {
        type: RESET_AGREEMENT_LIST,
        payload: []
    };
};

export const setSearchValueConnections = (searchVal) => {
    return {
        type: FILTER_CONNECTIONS,
        payload: searchVal
    };
};

export const resetShipmentRequest = () => {
    return {
        type: CLEAR_REQUEST,
        payload: []
    };
};

export const closeSnackBar = () => {
    return {
        type: CLOSE_SNACKBAR,
        payload: false
    };
};

export const showTable = () => {
    return {
        type: SHOW_TABLE,
        payload: true
    };
};

export const hideTable = () => {
    return {
        type: HIDE_TABLE,
        payload: false
    };
};

export const toggleAgreementSaveFlag = (flag) => (dispatch) => {
    dispatch({
        type: AGREEMENT_SAVE_FLAG,
        payload: flag
    });
};

export const storeNewConnectionId = (connectionId) => (dispatch) => {
    dispatch({
        type: STORE_NEW_CONNECTION_ID,
        payload: connectionId
    });
};

export const getTimeZones = () => (dispatch) => {
    const URL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/timezones`;

    axios.get(URL).then((response) => {
        dispatch({
            type: GET_TIMEZONES,
            payload: response.data
        });
    });
};

export const deleteConnections = (connection) => {
    return (dispatch, getState) => {
        const { sessionValue } = getState().session;
        const baseURL = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/v1/trustcenter/connections`;
        dispatch({
            type: HIDE_TABLE
        });
        dispatch({
            type: DISABLE_CONNECTION_OPERATIONS
        });
        dispatch({
            type: CONNECTION_CURRENT_OPERATION,
            payload: 'Deleting Connection(s)'
        });
        const headers = {
            account_id: sessionValue.accountId,
            tenant_id: sessionValue.tenant_id,
            user_id: sessionValue.userId,
            company_id: sessionValue.people_net_id,
            Authorization: 'Bearer ' + sessionStorage.getItem('access_token')
        };

        axios
            .delete(baseURL, { headers, data: connection })
            .then(() => {
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Connections deleted successfully'
                });
                dispatch(
                    getVisibilityConnections({
                        page: PAGE,
                        size: PAGE_SIZE,
                        sortOrder: SORT_ORDER.ASC,
                        sortField: SORT_FIELD,
                        searchTerm: ''
                    })
                );
            })
            .catch(() => {
                dispatch({
                    type: SHOW_TABLE
                });
            })
            .finally(() => {
                dispatch({
                    type: ENABLE_CONNECTION_OPERATIONS
                });
            });
    };
};
